import "../../../../assets/RideModalContent.css";
import _ from "clsx";
import d, { useRef as f, useState as w, useLayoutEffect as h } from "react";
const p = "_children_191jj_7", H = "_old_191jj_32", t = {
  "ride-modal-content": "_ride-modal-content_191jj_1",
  children: p,
  old: H,
  "large-content": "_large-content_191jj_39",
  new: "_new_191jj_51",
  "with-actions": "_with-actions_191jj_60",
  "without-actions": "_without-actions_191jj_67",
  "full-screen": "_full-screen_191jj_70"
};
function R({
  className: a,
  children: u,
  fullScreen: l,
  variant: i,
  hasActions: c,
  onLargeContentChange: n
}) {
  var o, r;
  const e = f(null), [j, m] = w(!1);
  return h(() => {
    if (!e.current) return;
    const s = e.current.scrollHeight > e.current.clientHeight;
    m(s), n == null || n(s);
  }, [(o = e.current) == null ? void 0 : o.scrollHeight, (r = e.current) == null ? void 0 : r.clientHeight]), /* @__PURE__ */ d.createElement(
    "div",
    {
      className: _(
        t["ride-modal-content"],
        a,
        t[i],
        {
          [t["full-screen"]]: i === "new" && l,
          [t["large-content"]]: !l && j,
          [t["with-actions"]]: c
        }
      )
    },
    /* @__PURE__ */ d.createElement(
      "div",
      {
        ref: e,
        className: _(t.children, {
          [t["with-actions"]]: c,
          [t["without-actions"]]: !c
        })
      },
      u
    )
  );
}
R.displayName = "RideModalContent";
export {
  R as RideModalContent
};
